const OfflineFakeData = {
  learningTyps: [
    {
      id: 1,
      name: 'Youth Learning',
      summary: 'Facilitate HUB modules with learners 12 - 18 years old',
      image: '/images/learning/type/image_1638692126280.svg',
      learning_type_key: 'youth-learning',
      learning_type_path: 'sectorList',
      learning_type_status: 'available',
      learning_type_order: '1',
      is_ui_gate: 1,
      is_record_menu: 1,
    },
    {
      id: 2,
      name: 'Adult Learning',
      summary: 'Facilitate HUB modules with learners 18 - 30 years old',
      image: '/images/learning/type/image_1638692138672.svg',
      learning_type_key: 'adult-learning',
      learning_type_path: 'sectorList',
      learning_type_status: 'available',
      learning_type_order: '2',
      is_ui_gate: 1,
      is_record_menu: 1,
    },
    {
      id: 3,
      name: 'Professional Development ',
      summary: 'Expert resources for HUB facilitators',
      image: '/images/learning/type/image_1639473654560.svg',
      learning_type_key: 'professional-development',
      learning_type_path: 'eventHome',
      learning_type_status: 'available',
      learning_type_order: '3',
      is_ui_gate: 1,
      is_record_menu: 0,
    },
    {
      id: 4,
      name: 'Facilitator Training',
      summary: ' ',
      image: null,
      learning_type_key: 'facilitator-training',
      learning_type_path: ' ',
      learning_type_status: 'available',
      learning_type_order: '4',
      is_ui_gate: 0,
      is_record_menu: 1,
    },
  ],
};

export default {
  fetch(key) {
    return OfflineFakeData[key];
  },
  /**
   * Validates the currently stored session in the vuex store
   */
  async query(options) {
    const queries = {
      '/api/facilitator-portal/sessions': () => {
        return {
          code: 200,
          success: true,
          message: 'OK',
        };
      },
      '/api/learning-types': () => {
        return {
          success: true,
          records: this.fetch('learningTyps'),
          message: 'OK.',
        };
      },
    };

    return { data: queries[options.url](options.data) };
  },
};
